import React from "react";

import { Dropdown, DropdownProps } from "primereact/dropdown";
import groupedUnits from "./units";

const DatasetUnitSelector = (props: DropdownProps) => {
  return (
    <Dropdown
      options={groupedUnits}
      optionLabel="label"
      optionGroupLabel="label"
      optionGroupChildren="items"
      filter
      editable
      {...props}
    />
  );
};

export default DatasetUnitSelector;
